exports = module.exports = require("../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hamberger{\n    width: 25%;\n    margin-top: 11% !important;\n    margin-left: -21% !important;\n    font-size: 1.4rem;\n    color: gray;\n}\n.cart{\n    width: 25%;\n    margin-top: 11% !important;\n    margin-left: 6% !important;\n    font-size: 1.7rem;\n    color: gray;\n}\n.cartheader{\n    font-size: 1.7rem;\n    color: gray;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main